import React, {useContext, useEffect} from "react";
import File from "../files/files";
import $ from 'jquery';
import FloContext from "../contexts/floContext";
import FolderOptions from "../options/folderOptions";

export default function Folders(props: any) {
   const { folder, index } = props;
   const droppableFolder: React.MutableRefObject<any>  = React.useRef();
   const {onDropping, onFolderRename, selectedToEditFolder}: any = useContext(FloContext)

   const enableDroppable = () => {
      $((droppableFolder.current) as any).droppable({
         accept: ".file",
         over: ( event, ui ) => {
            onDropping(folder);
         }
      })
   }

   const saveFolderName = (e: any) => {
      if (e._reactName === 'onKeyPress' && e.key === "Enter") {
         onFolderRename(folder, e.currentTarget.value)
      } else if (e._reactName === 'onBlur') {
         onFolderRename(folder, e.currentTarget.value)
      }
   }

   const stopPropagation = (e: any) => {
      e.stopPropagation();
   }

   useEffect(() => {
      enableDroppable();
   }, [])

   return (
       <li ref={droppableFolder} className={'accordion-sec folder '
           + (index === 0 ? 'open ' : '')
           + (selectedToEditFolder._id === folder._id ? 'edit-mode ' : '')}>
          <div className="folder-head options-box accordion-head flex">
             <div className="icon expand-rotate">
                <img src={require('../../assets/images/down-arrow.png')} alt=""/>
             </div>
             <div className="icon folder-icon">
                <img src={require('../../assets/images/folder.png')} alt=""/>
             </div>
             <div className="name">
                {
                   selectedToEditFolder._id === folder._id &&
                    <input defaultValue={folder.name}
                           onClick={stopPropagation}
                           autoFocus={true}
                           onBlur={saveFolderName}
                           onKeyPress={saveFolderName}
                           name="folder"
                           className="folder-name-edit" type="text"/>
                }
                {
                   selectedToEditFolder._id !== folder._id &&
                   <div className="text-ellipsis">{folder.name}</div>
                }
             </div>
             <FolderOptions folder={folder}/>
          </div>

          {/*........ files .......*/}
          <ul className="files accordion-content">
             {
                (folder.files).map((file: any, index: number) => {
                   return (
                       <File key={file._id}
                             file={file}
                             index={index}
                             folder={folder}
                             folderIndex={props.index}
                       />
                   )
                })
             }
          </ul>
       </li>
   )
}
